import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter, Route, Switch } from 'react-router-dom'

import ProtectedRoute from '../../ProtectedRoute'
import Home from '../../Components/Home/Index'
import Dashboard from '../../Components/Dashboard/Index'
import FrozenAccount from '../../Components/FrozenAccount/Index'
import { addDataToStore, UAM_SAVE_PERMISSIONS, SAVE_DATA, BNK_SAVE_DATA } from '../../Actions/actions'
import { getUserPermissions } from '../../Utils/userAccess'
import { message, Modal } from 'antd'
import { doSignout, trackEvent, apiPOSTReq } from '../../Utils/api'
import { isAnyAccountLockedOrClosed } from '../../Utils/util'
import { Auth } from 'aws-amplify'
import TwoFactor from '../Authentication/TwoFactor/Index'
import environment from '../../environment'


class AuthenticatedRouter extends Component {
    authIntervalTmr = null
    tabId = Date.now().toString();

    state = {
        show2FAModal: false,
        showFrozenAccountModal: false,
    }

    componentDidMount() {
        var { store, ReAuthenticate2FA } = this.props

        this.authIntervalTmr = setInterval(this.maintainAuth, 1000 * 15 * 60); // 15 mins = 9,00,000 ms

        // Track tab active and inactive states
        document.addEventListener('visibilitychange', this.handleTabVisibility);
        // Track tab closures
        window.addEventListener('beforeunload', this.handleTabClosure);

        // Handles logging out a user when all tabs/browser is closed
        this.initializeTab();

        // Save username
        const { cognitoUserInfo } = this.props.store;
        this.setState({
            username: (cognitoUserInfo || {}).username
        });

        // Track initial page view
        trackEvent({ name: "page_viewed", property: this.props.location.pathname });

        if (ReAuthenticate2FA) {
            this.handleReAuthenticate2FA();
        }

        const { UAM } = store
        const isAionCustomerSupportUser = UAM.aionCustomerSupportUser
        if (!isAionCustomerSupportUser) this.getAccounts()
    }

    componentWillUnmount() {
        console.log("componentWillUnmount");
        console.log("ARouter clearInterval maintainAuth");
        document.removeEventListener('visibilitychange', this.handleTabVisibility);
        window.removeEventListener('beforeunload', this.handleTabClosure);
        clearInterval(this.authIntervalTmr);
    }

    componentDidUpdate(prevProps) {
        // Check if TwoFAValidated has changed
        if (this.props.ReAuthenticate2FA !== prevProps.ReAuthenticate2FA) {
            if (this.props.ReAuthenticate2FA) {
                this.handleReAuthenticate2FA();
            }
        }

        // Check if the path has changed
        if (this.props.location.pathname !== prevProps.location.pathname) {
            // Track the new page view with the current path
            trackEvent({
                name: "page_viewed",
                property: this.props.location.pathname
            });
        }
    }

    updateTabCount = (increment) => {
        var tabCount = parseInt(localStorage.getItem('tabCount') || '0');
        tabCount += increment;
        localStorage.setItem('tabCount', tabCount.toString());
        console.log("tabCount", tabCount);
    };

    initializeTab = () => {
        this.updateTabCount(1);
        localStorage.setItem(`tab_${this.tabId}`, 'active');
    }

    performSignout = () => {
        message.info(`We've signed you out to keep things safe. Log back in anytime!`);
        this.props.doSignout(this.props.history, false, false, { username: this.state.username });
    }

    handleTabVisibility = () => {
        const { lastInActive, businessSwitched } = this.props.store;
        console.log("handleTabVisibility", document.hidden);
        if (document.hidden) {
            // Record timestamp
            this.props.dispatch(addDataToStore(SAVE_DATA, { lastInActive: new Date() }));
        } else {
            // message.info(`Last active more than 15 min: ${lastInActive && ((Date.now() - lastInActive) > 1000 * 15 * 60)} | ${moment(lastInActive).format('LTS')}`, 5);
            // Tab is active again. Check for 15 mins inactivity
            if (lastInActive && ((Date.now() - lastInActive) > 1000 * 15 * 60)) {
                console.log("signing out")
                this.props.dispatch(addDataToStore(SAVE_DATA, { lastInActive: null }));
                this.performSignout();
                return
            } else {
                // Reset
                this.props.dispatch(addDataToStore(SAVE_DATA, { lastInActive: null }));
            }
            Auth.currentUserInfo()
                .then(cognitoUserInfo => {
                    console.log("AuthRouter checkUserSession cognitoUserInfo", cognitoUserInfo)
                    if (!cognitoUserInfo) {
                        this.performSignout();
                        return
                    }
                })
                .catch(err => {
                    console.log("AuthRouter currentUserInfo Err", err);
                    this.performSignout();
                    return
                })

            var tabCount = parseInt(localStorage.getItem('tabCount') || '0');
            if (tabCount > 1 && businessSwitched) {
                this.props.dispatch(addDataToStore(SAVE_DATA, { businessSwitched: null })); // reset
                window.location.reload();
            }
        }
    }

    handleTabClosure = () => {
        // Record timestamp
        this.props.dispatch(addDataToStore(SAVE_DATA, { lastInActive: new Date() }));

        // Update tab count
        localStorage.removeItem(`tab_${this.tabId}`);
        this.updateTabCount(-1);
        // performance.navigation.type == 1 indicates a page refresh or new load. Do not perform a logout
        // if(![0, 1].includes(performance.navigation.type)) {
        //     // If this is the last tab, perform logout
        //     var tabCount = parseInt(localStorage.getItem('tabCount') || '0');
        //     console.log("tabCount handleTabClosure", tabCount);
        //     if (tabCount <= 0) {
        //         this.props.doSignout(this.props.history, false, false, { tabClosure: true, username: this.state.username });
        //     }
        // }

    }

    handleReAuthenticate2FA = () => {
        // Reset
        this.props.dispatch(addDataToStore(SAVE_DATA, { ReAuthenticate2FA: false }));

        this.setState({ show2FAModal: true });
    }

    twoFAValidated = () => {
        this.setState({ show2FAModal: false });
        window.location.reload();
    }

    maintainAuth = () => {
        // This will update permissions on window.reload
        // Refresh AionAuth
        const { TwoFAValidated } = this.props.store;

        console.log("ARouter Running interval maintainAuth", TwoFAValidated);

        if (TwoFAValidated) {
            console.log("ARouter TwoFAValidated maintainAuth");
            getUserPermissions(null, (err, resp) => {
                try {
                    if (err) throw Error(err)
                    if (!resp.data.authToken) throw Error(resp.data.responseMessage)
                    console.log("Running interval getUserPermissions")
                    this.props.dispatch(addDataToStore(UAM_SAVE_PERMISSIONS, { UAM: resp.data }))
                    // Notification({title: "Auth refresh", description: `Refresh time: ${moment().format("lll")} ${resp.data.authToken}`, duration: 0})
                } catch (error) {
                    console.log("maintainAuth Error", error.message, err, resp)
                }
            })
        }
    }

    getAccounts = () => {
        apiPOSTReq(`${environment.bbBaseUrl}/bb/getAccounts`, { "BankProvider": environment.bankProvider.crb }, null, (err, resp) => {
            try {
                console.log("/bb/getAccounts", err, resp)
                const data = resp
                if (data.result) {
                    if (err) throw new Error(err)
                    var accounts = data.bbaccounts

                    console.log("/bb/getAccounts", accounts)

                    this.props.dispatch(addDataToStore(BNK_SAVE_DATA, { BBAccounts: accounts }))

                    const lockedAccount = isAnyAccountLockedOrClosed(accounts)
                    if (lockedAccount) this.props.history.push('/frozen-account')
                } else {
                    throw Error(data.error || data.responseMessage || "Sorry we had trouble processing your request. Please try again later")
                }
            } catch (error) {
                console.log("ERRR getAccounts", error, err, resp)
            } finally {
                // setSubmitLoading(false)
            }
        })
    }

    render() {
        const { location } = this.props

        return (
            <>
                <Switch location={location}>
                    <Route exact path="/signout" component={Home} />
                    <ProtectedRoute exact path="/dashboard" component={Dashboard} />
                    <ProtectedRoute path="/apps" component={Home} />
                    <ProtectedRoute path="/banking" component={Home} />
                    <ProtectedRoute path="/daca" component={Home} />
                    <ProtectedRoute path="/cards" component={Home} />
                    <ProtectedRoute path="/credit" component={Home} />
                    <ProtectedRoute path="/receivables" component={Home} />
                    <ProtectedRoute path="/payables" component={Home} />
                    <ProtectedRoute path="/settings" component={Home} />
                    <ProtectedRoute path="/contractor-payroll" component={Home} />
                    <ProtectedRoute path="/callback" component={Home} />
                    <ProtectedRoute path="/approvals" component={Home} />
                    <ProtectedRoute path="/support" component={Home} />
                    <ProtectedRoute path="/underwriting" component={Home} />
                    <ProtectedRoute path="/frozen-account" component={FrozenAccount} />
                </Switch>

                <Modal
                    visible={this.state.show2FAModal}
                    footer={null}
                    closable={false}
                    style={{ top: 40 }}
                    destroyOnClose={true}
                    width={570}
                >
                    <TwoFactor twoFAValidated={() => this.twoFAValidated()} />
                </Modal>
            </>
        )
    }
}

function mapStateToProps(state) {
    return {
        store: state.aionAppReducer,
        ReAuthenticate2FA: state.aionAppReducer.ReAuthenticate2FA
    }
}

function mapDispatchToProps(dispatch) {
    return {
        dispatch,
        doSignout: (history, arg1, arg2, arg3) => dispatch(doSignout(history, arg1, arg2, arg3))
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AuthenticatedRouter))